//eslint-disable-next-line
import axios, { $asyncPost, $asyncGet, baseUrl } from "./common.js";

/**
 * 爬取搜狗图片
 * @param {string} keyword 关键字
 * @param {number} max 返回最大值
 */
export const souGouSearch = function (keyword, max = 5) {
  return new Promise((resolve, reject) => {
    axios.get("v3/common/image/sogou/Search?keyword=" + keyword + "&max=" + max).then(res => {
      if (res.data && res.data.return_code === "SUCCESS" && res.data.result_code === "SUCCESS" && res.data.resp_data) {
        resolve(res.data.resp_data);
      } else {
        resolve(false)
      }
    })
  })
}

/**
 * 判断商品是否存在
 * @param {string} data 需要搜索的商品 格式为 1,2,3
 * @returns Promise
 */
export const goodsIsExists = function (data) {
  return axios.post("v3/common/Basic/Goods/IsExists", data);
}

/**
 * 申请新品
 * @param {array} list {"barcode": "12","imageFront": 456,"advise_price": 0,"imageBarcode": 123,"imageDesc": 123}[]
 * @returns
 */
export const goodsApply = function (list) {
  return axios.post("v3/common/Basic/Goods/Apply", list);
}

/**
 * 获取待审核商品数据
 * @param {number} pageSize 每页数量
 * @param {number} pageNum 第几页
 * @returns
 */
export const goodsAuditList = function (pageSize = 100, pageNum = 0) {
  return axios.post(`v3/common/Basic/Goods/AuditList?pageSize=${pageSize}&pageNum=${pageNum}`, {});
}

/**
 * 审核商品信息
 * @param {array} list 待审核商品信息列表
 * @returns
 */
export const goodsAudit = function (list) {
  return axios.post("v3/common/Basic/Goods/audit", list);
}

/**
 * 获取商品信息
 * @param {string} value 需要搜索的值
 * @param {boolean} accurate 是否精确查询
 * @returns
 */
export const goodsSearch = function (value, accurate = true) {
  return new Promise((resolve, reject) => {
    axios.get("v3/common/Basic/Goods/Search?value=" + value + "&accurate=" + accurate).then(res => {
      if (res.data && res.data.return_code === "SUCCESS" && res.data.result_code === "SUCCESS" && res.data.resp_data && res.data.resp_data[0]) {
        resolve(res.data.resp_data[0]);
      } else {
        resolve(false);
      }
    })
  })
}

// /Common/v2/Basic/classify/list
/**
 * 获取基本类别
 * @returns {} 类别列表
 */
export const getClassifyList = function () {
  return new Promise((resolve, reject) => {
    axios.get("v3/common/Basic/classify/list").then(result => {
      if (result.data && result.data.return_code === "SUCCESS" && result.data.result_code === "SUCCESS" && result.data.resp_data) {
        const res = result.data.resp_data;
        const allList = res;
        var t2 = [];
        var t4 = [];
        var t6 = [];
        for (let i = 0; i < res.length; i++) {
          if (
            res[i].class_no.trim().length === 2 &&
            res[i].parent_class_no === "0"
          ) {
            t2.push({
              class_no: res[i].class_no,
              class_name: res[i].class_name,
              parent_class_no: res[i].parent_class_no,
              children: []
            });
          }
          if (res[i].class_no.trim().length === 4) {
            t4.push({
              class_no: res[i].class_no,
              class_name: res[i].class_name,
              parent_class_no: res[i].parent_class_no
            });
          }
          if (res[i].class_no.trim().length === 6) {
            t6.push({
              class_no: res[i].class_no,
              class_name: res[i].class_name,
              parent_class_no: res[i].parent_class_no
            });
          }
        }
        if (t6.length > 0) {
          for (let i = 0; i < t6.length; i++) {
            for (let j = 0; j < t4.length; j++) {
              if (t6[i].parent_class_no === t4[j].class_no) {
                t4[j].children.push(t6[i]);
              }
            }
          }
        }

        for (let i = 0; i < t4.length; i++) {
          for (let j = 0; j < t2.length; j++) {
            if (t4[i].parent_class_no.trim() === t2[j].class_no.trim()) {
              t2[j].children.push(t4[i]);
            }
          }
        }
        resolve({
          t2,
          allList
        })
      } else {
        resolve(false);
      }
    })
  })
}

/**
 * 上传图片接口
 * common/v2/UploadImg
 * @param {string} img base64
 * @param {string} file_type JPG,GIF,JPEG
 * @returns
 * 获取图片  `${ baseUrl }/media/image/${ res.data.resp_data.media_no }.${ file_type }`
 */
export const basicUploadImg = function (formData) {
  let url = "";
  if (localStorage.getItem("token_type") === "merchant") {
    url = `v3/common/media/UploadImage?merchant_id=${localStorage.getItem("merchant_id")}`
  } else {
    url = `v3/common/media/UploadImage?service_no=${localStorage.getItem("service_no")}`
  }
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
};

/**
 * 下载图片
 * @param {*} media_no 图片media_no
 */
export const basicDownLoadImg = function (media_no) {
  return $asyncPost(`v3/common/media/DownloadImage?media_no=${media_no}`);
}

/**
 * 获取缩略图
 * @param {string} media_no 媒体号
 * @returns string
 */
export const getThumbnailImage = function (media_no) {
  return `${baseUrl}/v3/Common/image/base/Thumbnail/${media_no}`;
}
/**
 * 获取正常图片
 * v3/Common/image/base/show/${media_no}
 * @param {string} media_no 媒体号
 * @returns string
 */
export const getBaseImage = function (media_no) {
  return `${baseUrl}/v3/Common/image/base/show/${media_no}`;
}